import { Autocomplete, TextField } from '@mui/material';

const CategorySelect = ({ categories = [], selectedCategory, setSelectedCategory, error, size = 'medium' }) => {
  return (
    <Autocomplete
      options={categories} // すでに flatten + level付き
      getOptionLabel={(option) => option.category_name}
      value={categories.find(o => o.category_id === selectedCategory) || null}
      onChange={(e, value) => setSelectedCategory(value ? value.category_id : '')}
      renderInput={(params) => (
        <TextField {...params} label="カテゴリー" placeholder="検索できます" fullWidth error={error} size={size} />
      )}
      sx={{ width: 500 }}
      renderOption={(props, option) => (
        <li {...props} style={{ paddingLeft: option.level * 16 + 16 }}>
          {option.category_name}
        </li>
      )}
    />
  );
};

export default CategorySelect;
